const addCitiesList = [
  { id: 1, city: 'Moscow', timeZone: 3 },
  { id: 2, city: 'Novosibirsk', timeZone: 7 },
  { id: 3, city: 'New York', timeZone: -4 },
  { id: 4, city: 'Tokyo', timeZone: 9 },
];

export default addCitiesList;
